module.exports = __webpack_public_path__ + "static/media/review-icon.efd5229d.svg";